var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeoscape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 4c5.523 0 10 4.477 10 10s-4.477 10-10 10S4 19.523 4 14 8.477 4 14 4zm2.53 14h-5.06c.203.81.468 1.545.783 2.177C12.881 21.432 13.553 22 14 22c.448 0 1.119-.568 1.747-1.823.315-.632.58-1.367.783-2.176zm-7.114.001H7.071a8.035 8.035 0 0 0 3.468 3.213c-.473-.906-.857-1.996-1.123-3.213zm11.513 0h-2.345c-.266 1.217-.65 2.307-1.122 3.214a8.043 8.043 0 0 0 3.467-3.214zM9.1 12H6.252A8.015 8.015 0 0 0 6 14c0 .69.088 1.361.252 2l2.848.001A19.829 19.829 0 0 1 9.1 12zm7.788 0h-5.776A17.763 17.763 0 0 0 11 14c0 .685.038 1.356.112 2.001h5.776a17.763 17.763 0 0 0 0-4.001zm4.86 0H18.9a19.83 19.83 0 0 1 0 4.001h2.848c.164-.64.252-1.31.252-2.001 0-.69-.087-1.36-.252-2zm-11.21-5.215-.026.013A8.035 8.035 0 0 0 7.07 10h2.346c.266-1.217.65-2.308 1.122-3.215zM14 6c-.448 0-1.119.568-1.747 1.823-.315.632-.58 1.368-.783 2.177h5.06a10.759 10.759 0 0 0-.783-2.177c-.591-1.182-1.22-1.754-1.666-1.817L14 6zm3.461.786.023.041c.462.899.838 1.975 1.1 3.173h2.346a8.035 8.035 0 0 0-3.469-3.214z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoscape);
export default __webpack_public_path__ + "static/media/geoscape.b469d134360d64cc094d9926a10aec13.svg";
export { ForwardRef as ReactComponent };